export default {
      id: "filter-usage",
      viewBox: "0 0 15 17",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#filter",
      toString: function () {
        return this.url;
      }
    }